const u = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  hero: "/assets/hero-veya.jpg",
  about: u("1649615644622-6d83f48e69c5"),
  fullbleed: u("1512453979798-5ea266f8880c", 2200),
};

export const SERVICES = [
  {
    n: "01",
    slug: "brand-launches",
    title: "BRAND LAUNCHES",
    desc: "Product launches, immersive brand experiences, private previews, press events and thoughtfully curated experiential activations.",
    img: "/assets/service-veya.jpg",
  },
  {
    n: "02",
    slug: "corporate-events",
    title: "CORPORATE EVENTS",
    desc: "Executive gatherings, corporate dinners, client events, conferences and company celebrations.",
    img: "/assets/service-cotia.jpg",
  },
  {
    n: "03",
    slug: "private-events",
    title: "PRIVATE EVENTS",
    desc: "Private dinners, birthdays, milestone celebrations and bespoke social gatherings.",
    img: "/assets/service-private.jpg",
  },
];

export const PROJECTS = [
  {
    slug: "the-velvet-hour",
    name: "The Velvet Hour",
    location: "Al Barari",
    type: "PRIVATE",
    typeLabel: "Private Celebration",
    year: "2025",
    guests: "60 guests",
    services: "Concept • Event Design • Styling • Private Dining • Guest Experience",
    story1: "An intimate birthday dinner for 60 guests, designed around one simple idea: make the evening feel deeply personal. The brief was to create an atmosphere that felt elegant without feeling formal, bringing together the warmth of Beirut, the intimacy of a private home and the drama of a late night dinner in the garden.",
    approach: "SORA developed the evening from the story outward. A single forty-foot dining table became the centrepiece of the celebration, stretching through the space and bringing every guest into one shared experience. Warm candlelight, understated styling and carefully considered details kept the setting atmospheric rather than over-designed. The menu was built around the celebrant's childhood in Beirut, turning familiar flavours and memories into a dining experience that unfolded course by course.",
    detail: "One table. Sixty guests. Three hundred candles.",
    img: u("1470337458703-46ad1756a187", 1200),
    ratio: "aspect-[4/5]",
    gallery: [u("1551024709-8f23befc6f87"), u("1465146344425-f00d5f5c8f07")],
  },
  {
    slug: "maison-lumiere",
    name: "Maison Lumière",
    location: "DIFC",
    type: "BRAND LAUNCHES",
    typeLabel: "Brand Launch",
    year: "2026",
    guests: "300 guests",
    services: "Brand experience, launch production",
    story1: "A fragrance house's regional debut, staged as a walk through light itself.",
    story2: "Sheer rooms of voile and projection led three hundred guests from scent to scent, ending in a candlelit salon where the maison's story was told in whispers.",
    detail: "Nine rooms of light, built in five days.",
    img: u("1475721027785-f74eccf877e2", 1200),
    ratio: "aspect-square",
    gallery: [u("1519167758481-83f550bb49b3"), u("1530103862676-de8c9debad1d")],
  },
  {
    slug: "fifty-candles",
    name: "Fifty Candles",
    location: "Emirates Hills",
    type: "PRIVATE",
    typeLabel: "Milestone Birthday",
    year: "2025",
    guests: "50 guests",
    services: "Private dining, entertainment",
    story1: "A fiftieth birthday staged as a private chef's table among the olive trees.",
    story2: "Fifty candles for fifty years — each lit by a different guest as dinner turned, gently and then all at once, into dancing.",
    detail: "Every guest lit one candle. Every candle held a wish.",
    img: u("1414235077428-338989a2e8c0", 1200),
    ratio: "aspect-[3/4]",
    gallery: [u("1510812431401-41d2bd2722f3"), u("1470509037663-253afd7f0f51")],
  },
  {
    slug: "the-founders-summit",
    name: "The Founders' Summit",
    location: "Dubai Opera",
    type: "CORPORATE",
    typeLabel: "Corporate Experience",
    year: "2026",
    guests: "220 guests",
    services: "Summit design, staging, production",
    story1: "A two-day founders' summit that felt more like a salon than a conference.",
    story2: "Warm light, sculptural florals and conversations staged like theatre — business, beautifully dressed, with not a lanyard in sight.",
    detail: "No lanyards. No banners. Just atmosphere.",
    img: u("1505236858219-8359eb29e329", 1200),
    ratio: "aspect-[3/4]",
    gallery: [u("1511578314322-379afb476865"), u("1519167758481-83f550bb49b3")],
  },
  {
    slug: "midnight-in-may",
    name: "Midnight in May",
    location: "Downtown Dubai",
    type: "PRIVATE",
    typeLabel: "Private Soirée",
    year: "2025",
    guests: "120 guests",
    services: "Concept, styling, entertainment",
    story1: "A rooftop soirée that began with jazz at dusk and ended with dancing well past three.",
    story2: "Champagne towers, a twelve-piece band and the Burj Khalifa keeping time overhead — the city itself was our backdrop.",
    detail: "The last guest left at 3:40 am. We counted it a success.",
    img: u("1533174072545-7a4b6ad7a6c3", 1200),
    ratio: "aspect-[4/5]",
    gallery: [u("1551024709-8f23befc6f87"), u("1414235077428-338989a2e8c0")],
  },
  {
    slug: "the-botanists-ball",
    name: "The Botanist's Ball",
    location: "Alserkal Avenue",
    type: "CORPORATE",
    typeLabel: "Gala Dinner",
    year: "2025",
    guests: "250 guests",
    services: "Gala design, creative direction",
    story1: "A gallery-district gala where every table was a different botanical study.",
    story2: "Ferns under glass, ikebana sculptures and a menu that moved from garden to garden — an evening curated like an exhibition.",
    detail: "Twenty-five tables. Twenty-five gardens.",
    img: u("1492684223066-81342ee5ff30", 1200),
    ratio: "aspect-[3/4]",
    gallery: [u("1530103862676-de8c9debad1d"), u("1511578314322-379afb476865")],
  },
];

